export default __webpack_public_path__ + "static/media/astronaut.ae54f37c.png";